module.exports = __webpack_public_path__ + "static/img/solutionDetailPic23.c78001f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic23.jpg
// module id = 88Zv
// module chunks = 1